import { Dispatch, RootState } from 'duck/store'
import { connect } from 'react-redux'
import { updateDealInfoBegin } from 'scenes/Dashboard/data/deals/actions'
import { Deal } from 'scenes/Dashboard/data/deals/types'
import { OrganizationSourceOptions } from 'scenes/Dashboard/data/organizations/types'

import { withStyles } from '@mui/styles'

import { DealInfo, DealInfoProps, styles } from './DealInfo.presentational'
import { DealInfoFormData, mapDealInfoToFormValues, mapFormValuesToDealInfo } from './DealInfoForm.data'

function mapStateToProps(state: RootState, { deal }: ContainerProps): StateProps {
  if (!deal) {
    return {
      receivedOn: '',
      source: OrganizationSourceOptions[0],
    }
  }

  const { notes, receivedOn, source } = mapDealInfoToFormValues(deal)

  return {
    dealId: deal.id,
    notes: notes || '',
    receivedOn,
    source,
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onSubmit: (dealId: Deal['id'], formData: DealInfoFormData) => {
    const dealData = mapFormValuesToDealInfo(formData)
    dispatch(updateDealInfoBegin(dealId, dealData))
  },
})

type StateProps = Pick<DealInfoProps, 'notes' | 'dealId' | 'receivedOn' | 'source'>
type ContainerProps = Pick<DealInfoProps, 'deal'>

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(DealInfo))
